import {observer} from "mobx-react";
import {useInjection} from "inversify-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import React from "react";
import SelectSearchMain from "@dropDesk/presentation/components/inputs/select_search_main";
import {TicketConfig} from "@dropDesk/domain/entities/ticket/ticket_config";
import {ICONS_DROPDESK} from "@dropDesk/storage/icons/icons.d";
import {Tooltip} from "antd";

const InputPrioritySearch = observer(
    ({
         setFilterPriority,
         filterPriority,
         loading,
         hideLabel,
         size
     }: {
        setFilterPriority: (filter: TicketConfig | null, withList?: boolean) => void,
        filterPriority: TicketConfig | null,
        loading: boolean,
        hideLabel?: boolean,
        size?: number
    }) => {

        const appController = useInjection(AppController);
        const colors = appController.theme.colorScheme;

        return (
            <>
                {!appController.isUserClient &&
                    <Tooltip title={hideLabel ? 'Filtrar por prioridade' : undefined}>
                        <div style={{display: "flex", flex: 1}}>
                            <SelectSearchMain<string>
                                disabled={loading}
                                size={size ?? 40}
                                useRemoveFilter={!!filterPriority}
                                label={hideLabel ? undefined : 'Filtrar por prioridade'}
                                placeHolder={"Pesquise por prioridade"}
                                options={appController.ticketPriorityConfigs.map((item) => item.toOptionType())}
                                removeSort={true}
                                onChange={(value: string | undefined) => {
                                    const priority = appController.getPriorityById(value);
                                    setFilterPriority(priority ?? null);
                                }}
                                value={filterPriority ? TicketConfig.translateStatusToHuman(filterPriority.description) : null}
                                iconLeftName={ICONS_DROPDESK.priority}
                                borderColor={filterPriority ? colors.accent : colors.border}
                            />
                        </div>
                    </Tooltip>
                }
            </>
        )
    })
export default InputPrioritySearch;
